import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css, cx, prefixCls }: any) => {
  return {
    chatInputArea: cx(
      `${prefixCls}-chatInputArea`,
      css`
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding-block: 0 16px;
        padding-inline: 0;
        border-radius: 12px;
        overflow: hidden;
        background: #fff;
        /* border: 1px solid #f0f1f3; */
        padding-top: 16px;
      `,
    ),
    textAreaWrap: css`
      display: flex;
      padding-block: 0;
      gap: 12px;
      padding-inline: 20px;
      .${prefixCls}-input {
        line-height: 1.2;
        border-radius: 0;
        font-size: 14px;
        resize: none;
        height: 100%;
        box-shadow: none;
        padding-block: 0;
        padding-inline: 0;
        min-height: 17px;
        background: transparent;
        border: none;
        position: relative;
        max-width: 100%;
        max-width: 100%;
        vertical-align: bottom;
        transition: all 0.3s, height 0s;
      }
    `,
    footerAddition: css`
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      gap: 8px;
      padding-inline: 20px;
    `,
  }
})
